module.exports = __webpack_public_path__ + "static/media/logo_gympass.fd65ef81.png";